<template>
  <div class="display" :class="{mini: mini}">
    <span class="label">{{label}}</span>
    <div class="levels-group">
      <span class="range low">{{lowRangeText}}</span>
      <span class="range med">{{medRangeText}}</span>
      <span class="range high">{{highRangeText}}</span>
      <div class="value" :class="valueRangeClass">
        <span class="val">{{value}}</span>
        <span class="unit">&#181;g/berry</span>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  name: 'TanninLevelDisplay',
  props: ['label', 'ranges', 'value', 'mini'],
  methods: {
    indexToLevelClass(index) {
      switch (index) {
        case 0:
          return 'vlow';
        case 1:
          return 'vmed';
        case 2:
          return 'vhigh';
        default:
          return '';
      }
    },
  },
  computed: {
    lowRangeText() {
      if (this.ranges.length > 3) {
        return `<${this.ranges[1]}`;
      }
      return '';
    },
    medRangeText() {
      if (this.ranges.length > 3) {
        return `${this.ranges[1]} - ${this.ranges[2]}`;
      }
      return '';
    },
    highRangeText() {
      if (this.ranges.length > 3) {
        return `>${this.ranges[2]}`;
      }
      return '';
    },
    valueRangeClass() {
      let finalLevel = 0;

      if (this.value < this.ranges[1]) {
        finalLevel = 0;
      } else if (this.value >= this.ranges[1] && this.value <= this.ranges[2]) {
        finalLevel = 1;
      } else {
        finalLevel = 2;
      }
      return this.indexToLevelClass(finalLevel);
    },
  },
};
</script>


<style lang="scss" scoped>
@import '../assets/_colors.scss';
@import '../assets/_globals.scss';

  .display{
    width: 100%;
    background-color: #f1f1f1;
    box-sizing: border-box;
  }

  .label{
    font-size: 1.3rem;
    text-transform: uppercase;
    display: block;
    text-align: center;
    padding: 1rem 0;
  }

  .display.mini{
    .label{
      font-size: .9rem;
      padding: .5rem 0;
    }
    .levels-group{
      grid-template-rows: auto 35px;
      padding-top: 0;
    }
    .range{
      font-size: .9rem;
      text-align: center;
    }
    .value{
      font-size: 1.3rem;
      height: 3rem;
    }
    .unit{
      font-size: .8rem;
    }
  }

  .levels-group{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto 40px;
    padding-top: 2rem;
  }

  .range{
    color: white;
    grid-row: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
  }
  .low{
    grid-column: 1;
    background: #66BB6A;
  }
  .med{
    grid-column: 2;
    background: #FFCA28;
  }
  .high{
    grid-column: 3;
    background: #E53935;
  }

  .value{
    grid-row: 1;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 5rem;
    font-size: 2rem;
    font-weight: 400;
    flex-direction: column;
  }
  .unit{
    font-weight: 300;
    font-size: .9rem;
  }
  .vlow{
    grid-column: 1;
    background: #81c784;
  }
  .vmed{
    grid-column: 2;
    background: #FFD54F;
  }
  .vhigh{
    grid-column: 3;
    background: #EF5350;
  }
</style>



// WEBPACK FOOTER //
// src/components/TanninLevelDisplay.vue